// Раздел «Места»: подразделы, город по умолчанию, контекст запроса, ссылка — чистые расчёты (покрыто тестами)
import type { ExploreContext } from '../../entities/poi';
import type { Picked } from '../../shared/ui/Autocomplete';

export const EXPLORE_TABS = ['food', 'sights', 'nature', 'activities', 'transport'] as const;
export type ExploreTab = (typeof EXPLORE_TABS)[number];
export const isExploreTab = (v: unknown): v is ExploreTab => typeof v === 'string' && (EXPLORE_TABS as readonly string[]).includes(v);

/** «Самарканд (SKD)» → «Самарканд» */
export const cityLabel = (label: string): string => String(label || '').replace(/\s*\([A-Z]{3}\)\s*$/, '').trim();

/** Город в форме: код IATA, если выбран из подсказок, иначе — введённое название */
export function cityParam(p: Picked | null | undefined): string {
  if (!p) return '';
  return (p.value || cityLabel(p.label)).trim();
}

/** Контекст запросов подразделов (null — город не выбран) */
export function makeContext(city: Picked | null, date: string, dateTo: string, near: ExploreContext['near'] = null): ExploreContext | null {
  const c = cityParam(city);
  if (!c || c.length < 2) return null;
  return { city: c, cityName: cityLabel(city!.label) || c, date: date || '', dateTo: dateTo && dateTo > date ? dateTo : '', near };
}

export interface CityHints {
  /** последний поиск авиабилетов */
  query?: { destination?: string; destinationName?: string } | null;
  /** последний город раздела «Места» */
  saved?: Picked | null;
  /** город пользователя (форма авиабилетов: сохранённый или по IP) */
  origin?: Picked | null;
}

/** Город по умолчанию: куда летит последний поиск → последний город раздела → город пользователя */
export function defaultCity(h: CityHints): Picked | null {
  const q = h.query;
  if (q && q.destination && /^[A-Z]{3}$/.test(q.destination)) {
    const name = cityLabel(q.destinationName || '') || q.destination;
    return { label: `${name} (${q.destination})`, value: q.destination };
  }
  if (h.saved && (h.saved.value || h.saved.label)) return h.saved;
  if (h.origin && h.origin.value) return h.origin;
  return null;
}

/** Ссылка на раздел: /?ecity=SKD&etab=sights#explore */
export function exploreLink(city: string, tab?: ExploreTab): string {
  const p = new URLSearchParams({ ecity: city });
  if (tab) p.set('etab', tab);
  return `/?${p}#explore`;
}

/** Разбор ссылки: город и подраздел */
export function parseLink(search: string): { city: string; tab: ExploreTab | null; date: string } | null {
  const p = new URLSearchParams(search);
  const city = (p.get('ecity') || '').trim();
  if (!city) return null;
  const tab = p.get('etab');
  const date = p.get('edate') || '';
  return { city, tab: isExploreTab(tab) ? tab : null, date: /^\d{4}-\d{2}-\d{2}$/.test(date) ? date : '' };
}
